import React, { memo } from 'react';
import { Button } from '../ui/Button';
import { CheckCircle2 } from 'lucide-react';
interface FinalCTAProps {
  onCTAClick?: () => void;
}
export function FinalCTA({
  onCTAClick
}: FinalCTAProps) {
  return <section className="py-12 md:py-16 lg:py-20 bg-slate-900 text-white" data-id="element-249">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-250">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8 tracking-tight px-2" data-id="element-251">
          Tu siguiente paso ahora mismo
        </h2>
        <div className="grid md:grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-12 text-left max-w-3xl mx-auto" data-id="element-252">
          {['Instala y abre HeyLloyd en tu Mac', 'Elige y descarga un Lloyd de la galería', 'Ábrelo con HeyLloyd y sigue las instrucciones'].map((step, i) => <div key={i} className="flex items-start p-3 md:p-4 bg-white/5 rounded-lg md:rounded-xl border border-white/10" data-id="element-253">
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-teal-400 mt-0.5 mr-2 md:mr-3 flex-shrink-0" data-id="element-254" />
              <span className="text-slate-200 text-sm md:text-base" data-id="element-255">
                {step}
              </span>
            </div>)}
        </div>
        <p className="text-slate-400 mb-8 md:mb-10 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-256">
          No necesitas memorizar nada ni entender toda la tecnología. Solo
          tienes que seguir los pasos que HeyLloyd te muestra, clic a clic.
        </p>
        <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" onClick={onCTAClick} data-id="element-257">
          <Button variant="cyan" size="lg" className="w-full md:w-auto text-base md:text-lg px-8 md:px-12 py-4 md:py-6" data-id="element-258">
            Empezar ahora con HeyLloyd
          </Button>
        </a>
      </div>
    </section>;
}